import React, { useEffect } from 'react';
import Countdown from "react-countdown"
import { CountDownContainer, CountDownText, PrimaryColorText } from './sub-components';
import { isDate, parse } from 'date-fns';
import { Close as CloseIcon, OpenInNew as OpenInNewIcon } from "@material-ui/icons"
import { Typography, IconButton } from "@material-ui/core"
import _ from 'lodash';
import { Link } from 'gatsby';
import { fireGtmEvent } from '../../functions';

const CampaignBanner = ({ isCountdown, liveUntil = '2024-04-28 23:59:59+0800', countDownTexts = {}, link, bannerText = '', backgroundColor = 'secondary', bgImage = "", justImage=false, isPopup=false, eventId='' }) => {

    // const [isPopupOpen, setIsPopupOpen] = React.useState(false);
    const [isPopupShown, setIsPopupShown] = React.useState(false);

    useEffect(() => {
        sessionStorage.getItem('popupShown') ? setIsPopupShown(true) : setIsPopupShown(false);
    }, [isPopupShown]);

    const handleClose = () => {
        fireGtmEvent({
            "event": "trackEventNoEcommerce",
            "eventDetails.category": "SEO Flights",
            "eventDetails.action": "click",
            "eventDetails.label": "seo|flights|indothai|close"
        });
        sessionStorage.setItem('popupShown', true);
        setIsPopupShown(true);
    };

    if(isPopupShown){
        return null;
    }
    else if(justImage && isDate(parse(liveUntil, 'yyyy-MM-dd HH:mm:ssxxxx', new Date('2024-08-25 23:59:59+0000')))){
        fireGtmEvent({
            "event": "trackEventNoEcommerce",
            "eventDetails.category": "SEO Flights",
            "eventDetails.action": "view",
            "eventDetails.label": "seo|flights|desktoppromo|"+eventId
        });
        return(
            <Link to={link} style={{ textDecoration: 'none' }}>
                <CountDownContainer backgroundColor={backgroundColor} style={{padding: 0, minHeight: "unset"}} isPopup={isPopup}>
                    <img src={bgImage} alt="banner image" style={{ width: '100%', height: '100%', maxWidth: 970, display: 'inline-flex', flexShrink: 1, maxWidth: "80%" }} onClick={() => {
                        fireGtmEvent({
                            "event": "trackEventNoEcommerce",
                            "eventDetails.category": "SEO Flights",
                            "eventDetails.action": "click",
                            "eventDetails.label": "seo|flights|desktoppromo|" + eventId
                        });
                    }} />
                    <IconButton className='close-icon-btn' style={{border: '1px solid white', marginTop: 16}} onClick={handleClose}>
                        <CloseIcon style={{ color: 'white', fontSize: '28px' }} />
                    </IconButton>
                </CountDownContainer>
             </Link>
        )
    }

    else if (isCountdown && isDate(parse(liveUntil, 'yyyy-MM-dd HH:mm:ssxxxx', new Date('2024-04-21 23:59:59+0000')))) {
        fireGtmEvent({
            "event": "trackEventNoEcommerce",
            "eventDetails.category": "SEO Flights",
            "eventDetails.action": "view",
            "eventDetails.label": "seo|flights|desktoppromo|"+eventId
        });
        return (
            <Countdown date={new Date(liveUntil).getTime()} zeroPadDays={2} zeroPadTime={2} renderer={
                ({ days, hours, minutes, seconds }) => (
                    <Link to={link} style={{ textDecoration: 'none' }}>
                        <CountDownContainer backgroundColor={backgroundColor}>
                            {!_.isEmpty(bgImage) && <img src={bgImage} alt="bgImage" style={{ width: '60px', height: '60px', display: 'inline-flex', flexShrink: 1, background: 'transparent' }} />}
                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                {_.get(countDownTexts, 'preText', '')}
                            </span>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', minWidth: 80, height: 40 }}>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: 48, height: 36, color: 'red', borderRadius: 4, background: 'white', marginInline: 4 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <CountDownText number={Math.floor(days / 10)} unit='tenth' />
                                        <CountDownText number={Math.floor(days % 10)} unit='oneth' />
                                    </div>
                                    <Typography variant="caption" style={{ color: 'red', fontSize: '8px', fontFamily: '"Orbitron"', textTransform: 'uppercase' }}>
                                        <PrimaryColorText>{_.get(countDownTexts, 'days', '')}</PrimaryColorText>
                                    </Typography>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: 48, height: 36, color: 'red', borderRadius: 4, background: 'white', marginInline: 4 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <CountDownText number={Math.floor(hours / 10)} unit='tenth' />
                                        <CountDownText number={hours % 10} unit='oneth' />
                                    </div>
                                    <Typography variant="caption" style={{ color: 'red', fontSize: '8px', fontFamily: '"Orbitron"', textTransform: 'uppercase' }}>
                                        <PrimaryColorText>{_.get(countDownTexts, 'hours', '')}</PrimaryColorText>
                                    </Typography>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: 48, height: 36, color: 'red', borderRadius: 4, background: 'white', marginInline: 4 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <CountDownText number={Math.floor(minutes / 10)} unit='tenth' />
                                        <CountDownText number={hours % 10} unit='oneth' />
                                    </div>
                                    <Typography variant="caption" style={{ color: 'red', fontSize: '8px', fontFamily: '"Orbitron"', textTransform: 'uppercase' }}>
                                        <PrimaryColorText>{_.get(countDownTexts, 'minutes', '')}</PrimaryColorText>
                                    </Typography>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: 48, height: 36, color: 'red', borderRadius: 4, background: 'white', marginInline: 4 }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <CountDownText number={Math.floor(seconds / 10)} unit='tenth' animDelay={seconds % 10} />
                                        <CountDownText number={seconds % 10} unit='oneth' type='seconds' />
                                    </div>
                                    <Typography variant="caption" style={{ color: 'red', fontSize: '8px', fontFamily: '"Orbitron"', textTransform: 'uppercase' }}>
                                        <PrimaryColorText>{_.get(countDownTexts, 'seconds', '')}</PrimaryColorText>
                                    </Typography>
                                </div>

                            </div>
                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                {_.get(countDownTexts, 'subText', '')}
                                <OpenInNewIcon className='countdownIcon' style={{ color: 'white', fontSize: '28px' }} />
                            </span>
                        </CountDownContainer>
                    </Link>
                )
            } />
        )
    }
    else{
        return (
            <Link to={link} style={{ textDecoration: 'none' }}>
                <CountDownContainer backgroundColor={backgroundColor}>
                    {/* <img src={bgImage} alt="bgImage" style={{ width: '100%', height: '100%', display: 'inline-flex', flexShrink: 1 }} /> */}
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                        {bannerText}
                        <OpenInNewIcon className='countdownIcon' style={{ color: 'white', fontSize: '28px' }} />
                    </span>
                </CountDownContainer>
            </Link>
        );
    }
};

export default CampaignBanner;